import React from 'react';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';

import { Clear, Iteration } from 'grommet-icons';
import { Stack } from 'grommet';
import Button from 'app/components/Button';

const ClearIcon = styled(Clear)`
  transform: translateY(2px);
  width: 52px;
  height: 52px;
  @media (max-width: 600px) {
    width: 28px;
    height: 28px;
  }
`;
const BookmarksIcon = styled(Iteration)`
  transform: translateY(2px);
  width: 26px;
  height: 26px;
  @media (max-width: 600px) {
    transform: translateY(0px);
    width: 14px;
    height: 14px;
  }
`;

function ClearBookmarksButton({ AppState }) {
  return (
    <Button
      direction="column"
      pad="small"
      onClick={() => {
        AppState.setMenuBar('USER_IS_CLEARING');
      }}
    >
      <Stack anchor="center">
        <ClearIcon size="large" color="accent-1" />
        <BookmarksIcon color="accent-1" />
      </Stack>
    </Button>
  );
}

export default inject('AppState')(observer(ClearBookmarksButton));



// WEBPACK FOOTER //
// ./src/app/components/BookmarkMenu/ClearBookmarksButton.js